import { FieldValues } from 'react-hook-form';
import { SERVICE_PROVIDERS } from 'modules/graphql/types';
import { ESP_ACCOUNT_PAYLOAD_FIELDS, AuthType } from '../../types';
import {
  DYN,
  SPARKPOST,
  MAILGUN,
  SENDGRID,
  TELNYX,
  TWILIO,
  ITERABLE_SMS,
  CUSTOM_EMAIL,
  ConfigurableSendingPlatforms,
  WHATS_APP,
} from '../../constants/sendingPlatforms';

const {
  NAME,
  API_KEY,
  ESP,
  BINDING,
  API_ENDPOINT,
  SIGNING_SECRET,
  IS_SENDER_ITERABLE,
  CLIENT_ID,
  CLIENT_SECRET,
  TOKEN_ENDPOINT,
  AUTH_TYPE,
  CUSTOM_HEADERS,
} = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const DEFAULT_VALUES: Record<ConfigurableSendingPlatforms, FieldValues> = {
  [DYN]: { [ESP]: SERVICE_PROVIDERS.DYN, [NAME]: '', [API_KEY]: '' },
  [SPARKPOST]: {
    [ESP]: SERVICE_PROVIDERS.SPARKPOST,
    [NAME]: '',
    [API_KEY]: '',
    [BINDING]: '',
    [API_ENDPOINT]: '',
  },
  [MAILGUN]: {
    [ESP]: SERVICE_PROVIDERS.MAILGUN,
    [NAME]: '',
    [API_KEY]: '',
  },
  [WHATS_APP]: {
    [ESP]: SERVICE_PROVIDERS.INFOBIP,
    [NAME]: '',
    [API_KEY]: '',
  },
  [SENDGRID]: { [ESP]: SERVICE_PROVIDERS.SENDGRID, [NAME]: '', [API_KEY]: '' },
  [TELNYX]: { [ESP]: SERVICE_PROVIDERS.TELNYX, [NAME]: '', [API_KEY]: '', [SIGNING_SECRET]: '' },
  [TWILIO]: { [ESP]: SERVICE_PROVIDERS.TWILIO, [NAME]: '', [API_KEY]: '', [API_ENDPOINT]: '' },
  [ITERABLE_SMS]: {
    [ESP]: SERVICE_PROVIDERS.TWILIO,
    [NAME]: '',
    [API_KEY]: '',
    [API_ENDPOINT]: '',
    [IS_SENDER_ITERABLE]: true,
  },
  [CUSTOM_EMAIL]: {
    [ESP]: SERVICE_PROVIDERS.CUSTOM_MTA,
    [NAME]: '',
    [API_ENDPOINT]: '',
    [AUTH_TYPE]: AuthType.OAUTH2,
    [CLIENT_ID]: '',
    [CLIENT_SECRET]: '',
    [TOKEN_ENDPOINT]: '',
    [CUSTOM_HEADERS]: [],
  },
  /** Other providers to follow */
};
